/**
 * Get the ALEX URL for the current environment
 *
 * Priority:
 * 1. window.ENV.ALEX_CLIENT (runtime configuration)
 * 2. Dynamically construct from current domain (e.g., explore.ald-test-os1.net → alex.ald-test-os1.net)
 * 3. Fallback to production URL
 *
 * This ensures ALEX links stay within the same environment (test-os1, test-os2, old-staging, production)
 */
export const getAlexUrl = () => {
  // Check runtime environment variable first (for Docker/explicit configs)
  if (typeof window !== 'undefined' && window.ENV?.ALEX_CLIENT) {
    return window.ENV.ALEX_CLIENT;
  }

  // Dynamically construct URL from current domain
  if (typeof window !== 'undefined' && window.location?.host) {
    const currentHost = window.location.host;
    const protocol = window.location.protocol;

    // Replace 'explore' subdomain with 'alex' subdomain
    // Examples:
    //   explore.ald-test-os1.net → alex.ald-test-os1.net
    //   explore.ald-old-staging.net → alex.ald-old-staging.net
    //   explore.admiredleadership.com → alex.admiredleadership.com
    const alexHost = currentHost.replace(/^explore\./, 'alex.');

    // If we successfully replaced 'explore', use the dynamic URL
    if (alexHost !== currentHost) {
      return `${protocol}//${alexHost}`;
    }
  }

  // Fallback to production URL
  return 'https://alex.admiredleadership.com';
};

export default getAlexUrl;

